<div class="header">
  <h1>{{ statusMessage }}</h1>
  <mat-chip-list *ngIf="statusMessage">
    <mat-chip color="primary" selected class="count-chip">{{
      contractArray.length || 0
    }}</mat-chip>
  </mat-chip-list>
</div>
<div class="table-container">
  <div class="content">
    <div class="filter">
      <mat-form-field appearance="standard">
        <mat-label>Filter Contracts</mat-label>
        <input
          matInput
          (keyup)="filterContracts($event)"
          #input
          placeholder="ex. John Doe"
        />
      </mat-form-field>
    </div>

    <table
      mat-table
      [dataSource]="dataSource"
      class="table"
      matSort
      fixedLayout="true"
    >
      <ng-container matColumnDef="contractId">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Contract ID</th>
        <td mat-cell *matCellDef="let contract">
          {{ contract.contractId || "n/a" }}
        </td>
      </ng-container>
      <ng-container matColumnDef="notes">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Notes</th>
        <td mat-cell *matCellDef="let contract">
          {{ contract.notes || "n/a" }}
        </td>
      </ng-container>
      <ng-container matColumnDef="customerName">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Customer Name</th>
        <td mat-cell *matCellDef="let contract">
          {{ contract.customerName || "n/a" | titlecase }}
        </td>
      </ng-container>
      <ng-container matColumnDef="jobaddress">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Job Address</th>
        <td mat-cell *matCellDef="let contract">
          {{ contract.jobaddress || "n/a" | titlecase }}
        </td>
      </ng-container>
      <ng-container matColumnDef="contractDate">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Contract Date</th>
        <td mat-cell *matCellDef="let contract">
          {{ contract.contractDate | date : "shortDate" }}
        </td>
      </ng-container>
      <ng-container matColumnDef="estimator">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Sales Rep</th>
        <td mat-cell *matCellDef="let contract">
          {{ contract.estimator || "n/a" | titlecase }}
        </td>
      </ng-container>
      <ng-container matColumnDef="contractTotal">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Total $</th>
        <td mat-cell *matCellDef="let contract">
          {{ contract.contractTotal | currency : "USD" }}
        </td>
      </ng-container>
      <ng-container matColumnDef="zoneName">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Zone</th>
        <td mat-cell *matCellDef="let contract">
          {{ contract.zoneName || "n/a" | titlecase }}
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>

      <tr class="mat-row" *matNoDataRow [ngStyle]="{ 'text-align': 'center' }">
        <td class="mat-cell" [attr.colspan]="displayedColumns.length">
          No matching contracts found
        </td>
      </tr>
      <tr
        mat-row
        *matRowDef="let row; columns: displayedColumns"
        (click)="goToContract(row)"
      ></tr>
    </table>

    <div *ngIf="isLoading" class="spinner">
      <mat-spinner color="accent" mode="indeterminate"></mat-spinner>
    </div>

    <mat-paginator
      [pageSize]="100"
      [pageSizeOptions]="[10, 50, 100, 150, 500]"
      showFirstLastButtons
    ></mat-paginator>
  </div>
</div>
